export default __webpack_public_path__ + "static/media/thumbnail-m-cushion@3x.162cc885.png";